import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";

@Injectable()
export class RequireMagicTokenParamGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const magicToken = route.queryParams.token;
    return magicToken != null && typeof magicToken === "string";
  }
}
